import * as React from 'react';
export const IcPro = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.5 11H7v1h.5a.5.5 0 000-1zM12 2a10 10 0 100 20 10 10 0 000-20zM7.5 13H7v.5a.5.5 0 01-1 0v-3a.5.5 0 01.5-.5h1a1.5 1.5 0 110 3zm5.28.08a.51.51 0 01.14.7.52.52 0 01-.42.22.57.57 0 01-.28-.08L11 13.1v.4a.5.5 0 01-1 0v-3a.5.5 0 01.5-.5h1a1.5 1.5 0 011.314 2.221c-.123.22-.3.406-.514.539l.48.32zM16 14a2 2 0 110-4 2 2 0 010 4zm-4.5-3H11v1h.5a.5.5 0 000-1zm4.5 0a1 1 0 100 2 1 1 0 000-2z'
      fill='currentColor'
    />
  </svg>
);
